import React from "react";
import "./Loading.css";

export const createLoadingComponent = name => ({
  isLoading,
  error,
  pastDelay
}) => {
  if (isLoading) {
    return pastDelay ? (
      <div className="Loading">
        <div className="LoadingContent">Loading {name}...</div>
      </div>
    ) : null;
  } else if (error) {
    return (
      <div className="Loading">
        <div className="LoadingContent">Error! {name} failed to load.</div>
      </div>
    );
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/components/Loading.js